import React from 'react';
import querystring from 'querystring';

import { Main, MainHeader, Body } from 'components/Main';
import { Panel, PanelTop } from 'components/Panel';

export default class LeagueTablesPage extends React.Component {
    componentDidMount() {
        if (window !== undefined) {
            window.addEventListener('popstate', event => {
                let params = {};
                if (window.location.search) {
                    params = querystring.parse(window.location.search.substring(1));
                }
                this.props.browserBack(window.location.pathname, params);
            });
        }
    }

    render() {
        const { seasons, tables } = this.props;
        return (
            <Main>
                <MainHeader />
                <Body id="league-tables-page">
                    {seasons.map(season => <LeagueTables key={season} season={season} tables={tables[season]} />)}
                </Body>
            </Main>
        );
    }
}

const LeagueTables = ({ season, tables }) => (
    <Panel>
        <PanelTop title={`League Tables ${season}`} />
        {tables.map(table => <LeagueTable key={table.tid} table={table} />)}
    </Panel>
);

const LeagueTable = ({ table }) => (
    <div className="cc-card">
        <div className="league-table-team">{table.lname}</div>
        <div className="league-table-link">
            <a href={table.link} target="_blank">
                {table.description}
            </a>
        </div>
    </div>
);



// WEBPACK FOOTER //
// ./src/views/league-tables/LeagueTablesPage.jsx